import { downloadNote, getNoteContent } from './course_note_panel_new'
import { debounce } from 'lodash'
Vue.component("my_note_panel", {
  props: {
    course_info: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      keyword: '',  
      info: {},
      treeInfo: [],
      onlyDiff: false,//只看重难点
      diffTreeInfo: [],
      treeProps: {
        label: (data) => {
          return data.info.chapter_name
        },
        children: 'childInfo',
      },
      imgSrc: '',
      isMobile: window.innerWidth <= 768,
    }
  },
  // computed: {
  //   isMobile() {
  //     return window.innerWidth <= 768;
  //   }
  // },
  watch: {
    course_info: {
      handler(newVal) {
        if (!Object.keys(newVal).length) return
        this.getData()
      },
      immediate: true
    }
  },
  mounted() {
    window.addEventListener('resize', this.isMobileFn)
  },
  beforeDestroy() {
     window.removeEventListener('resize',this.isMobileFn)
  },
  methods: {
     isMobileFn: debounce(function (){
       console.log('window.innerWidth',window.innerWidth,window.innerWidth <= 768)
         this.isMobile =  window.innerWidth <= 768;
     },200),
    getData() {
      API.reqNoteChapter(this.course_info).then(res => {
        if (res.statusCode == 200) {
          this.info = res.data.info || {}
          let treeData = res.data.childInfo || []
          //是否显示章节序号
          if (entityData.chapter_display != 0) {
            this.treeInfo = treeData.map((c, i) => {
              let info = { ...c.info, chapter_name: this.$t('第章', { num: i + 1 }) + ' ' + c.info.chapter_name }
              let sort = 0
              let childInfo = c.childInfo.map((s, j) => {
                // console.log(s)
                if (!s.info.resourse_type) sort++
                let info = { ...s.info, chapter_name: (s.info.resourse_type ? '' : ((i + 1) + '.' + sort)) + '  ' + s.info.chapter_name }
                return {
                  ...s,
                  info
                }
              })
              return {
                ...c,
                childInfo,
                info
              }
            })
          } else {
            this.treeInfo = treeData
          }
          this.bindKeyframePreview()
          this.diffTreeInfo = this.getDiffTreeInfo(JSON.parse(JSON.stringify(this.treeInfo)))
          console.log('diffTreeInfo', this.diffTreeInfo)
        }
      })
    },
    bindKeyframePreview() {
      const that = this
      this.$nextTick(() => {
        let imgDomList = document.querySelectorAll('.right_content img:not(.icon)')
        for (let i = 0; i < imgDomList.length; i++) {
          imgDomList[i].onclick = function (e) {
            that.imgSrc = e.currentTarget.src
            that.$refs.previewImgRef.clickHandler()
          }
        }
      })
    },
    handleChapterClick(node) {
      let dom = document.getElementById('note_' + node.info.guid_)
      if (dom) {
        dom.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" })
      }
    },
    handleDownload() {
      let data = []
      let courseName, resourceName
      function getData(childInfo) {
        childInfo.map(el => {
          if (el.info.notes && el.info.notes.length) {
            el.info.notes.map(item => {
              let note = ''
              if (item.type != 'richText') {
                note = getNoteContent(item)
              } else {
                note = item.note
              }
              data.push({
                courseName: item.courseName,
                sectionName: item.sectionName,
                resourceName: item.resourceName,
                noteContent: note,
                isLearn: true,
                noteType: 'richText'
              })
              if (!courseName) courseName = item.courseName
              if (!resourceName) resourceName = item.resourceName
            })
          }
          if (el.childInfo && el.childInfo.length) {
            getData(el.childInfo)
          }
        })
      }
      getData(this.treeInfo)
      if (data.length) {
        downloadNote(data, { courseName })
      }
    },
    handleSearch(keyword) {
      console.log(keyword)
      // let els = []
      // // 递归函数，用于在 DOM 树中查找元素
      // function searchElements(element) {
      //   // 检查当前元素是否为所需类型
      //   if (element.textContent.includes(keyword) && !element.childNodes.length) {
      //     console.log('找到匹配项：', element);
      //     els.push(element)
      //   }
      //   // 遍历子元素
      //   for (let i = 0; i < element.childNodes.length; i++) {
      //     searchElements(element.childNodes[i]);
      //   }
      // }
      // searchElements(this.$refs.richTextNote)
      // if (els.length) {
      //   els[0].parentNode.scrollIntoView({ behavior: 'smooth', block: 'start' });
      //   // this.$message.success('已定位到关键词')
      //   console.log('找到' + els.length + '条记录')
      // } else {
      //   this.$message.info('未找到关键词')
      // }
    },
    getDiffTreeInfo(treeInfo) {
      let filter = (arr) => {
        return arr.filter(item => {
          if (item.childInfo && item.childInfo.length) {
            filter(item.childInfo)
          }
          const regex = new RegExp('<div class="custom_time"(.*?)</div>');
          if (item.info.notes && item.info.notes.length) {
            item.info.notes.map(el => {
              if (!el.note) return el
              let arr = []
              el.note.replaceAll(regex, match => {
                arr.push(match)
              })
              el.note = arr.join('')
            })
            item.info.notes = item.info.notes.filter(el => el.note.trim())
          }
          return item.info.keyCount || item.info.difficultCount
        })
      }
      return filter(treeInfo)
    },
    deleteSucess() {
      this.getData()
    }
  },
  template: `
  <div class="my_note_panel">
    <el-image 
      ref="previewImgRef"
      style="display: none"
      :src="imgSrc" 
      :preview-src-list="[imgSrc]">
    </el-image>
    <div class="panel_left">
      <div class="left_header">
        <span>章节目录</span>
        <span>共标记{{info.keyCount || 0}}个重点，{{info.difficultCount || 0}}个难点</span>
      </div>
      <el-tree :data="treeInfo" :props="treeProps" @node-click="handleChapterClick">
        <span class="note_tree_node" :class="{parent: !data.info.resource_attributes}" slot-scope="{ node, data }">
          <span>{{ node.label }}</span>
          <span v-if="node.level == 1" class="tags_wrap">
            <span v-if="data.info.keyCount" class="tag important">{{data.info.keyCount}}个重点</span>
            <span v-if="data.info.difficultCount" class="tag difficult">{{data.info.difficultCount}}个难点</span>
          </span>
        </span>
      </el-tree>
    </div>
    <div class="panel_right">
      <div class="right_header">
        <el-input v-model="keyword" suffix-icon="el-icon-search" placeholder="搜索文字内容，时间点名称" @change="handleSearch"></el-input>
        <div class="header_right">
          <el-checkbox v-model="onlyDiff" label="只看重难点"></el-checkbox>
          <el-button v-if="!isMobile" type="primary" size="small" @click="handleDownload">下载笔记</el-button>
        </div>
      </div>
      <div class="right_content" ref="richTextNote">
        <div class="chapter" v-for="(chapter, i) in onlyDiff?diffTreeInfo:treeInfo" :key="i">
          <div class="chapter_title">{{chapter.info.chapter_name}}</div>
          <my_note_content v-if="chapter.info.notes && chapter.info.notes.length"  :data="chapter.info" :keyword="keyword" @delete="deleteSucess"></my_note_content>
          <div class="chapter_content" v-else v-for="(section, j) in chapter.childInfo" :key="j">
            <div class="section_title">{{section.info.chapter_name}}</div>
            <my_note_content v-if="section.info.notes && section.info.notes.length" :data="section.info" :keyword="keyword" @delete="deleteSucess"></my_note_content>
            <div class="section_content" v-else v-for="(courseWare, i) in section.childInfo" :key="j">
              <my_note_content v-if="courseWare.info.notes && courseWare.info.notes.length" :data="courseWare.info" :keyword="keyword" @delete="deleteSucess"></my_note_content>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  `,
});